import { Component, ChangeDetectionStrategy } from "@angular/core";
import { AccessibilityService } from "../accessibility/accessibility.service";
import { DeviceDetectService } from "../../services/device-detect.service";
import { TranslatePipe } from "@ngx-translate/core";
import { SkipLinkDirective } from "../../directives/skip-link.directive";

@Component({
    selector: "app-skip-link",
    templateUrl: "./skip-link.component.html",
    styleUrls: ["./skip-link.component.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
      SkipLinkDirective,
      TranslatePipe
    ]
})
export class SkipLinkComponent {

  isMobile = false;

  constructor(
    private accessibility: AccessibilityService,
    private deviceDetectService: DeviceDetectService,
  ) {
    this.isMobile = this.deviceDetectService.isMobile;
  }

  onSkipLinkFocus() {
    this.accessibility.updateShowSkipLink(true);
  }

  onSkipLinkFocusOut() {
    this.accessibility.updateShowSkipLink(false);
  }
}
